var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{staticClass:"page-tabs",attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }